import { createSlice } from "@reduxjs/toolkit";

// Interface
import { IInitialState } from "./type";

const initialState: IInitialState = {
  abcWords: [],
  alphabet: [],
  currentLetter: 'A',

  input: '',
  loadingABC: false,
};

export const allDrugsVocabularySlice = createSlice({
  name: "allDrugsVocabulary",
  initialState: initialState,
  reducers: {
    getABC: (state) => {
      state.loadingABC = true;
    },
    getABCError: (state) => {
      state.loadingABC = false;
    },
    getABCSuccess: (state, action) => {
      state.loadingABC = false;

      state.abcWords = action.payload.abcWords;
      state.alphabet = action.payload.alphabet;
    },

    handlerChangeLetter: (state, action) => {
      state.currentLetter = action.payload;
    },

    handlerChangeInput: (state, action) => {
      state.input = action.payload;
    },
  }
});

export const {
  getABC,
  getABCError,
  getABCSuccess,

  handlerChangeInput,
  handlerChangeLetter,
} = allDrugsVocabularySlice.actions;

export default allDrugsVocabularySlice.reducer;
